import {createContext} from 'react'
import {StudentContext} from './_context'

export const StudentProvider = StudentContext.Provider
